import * as React from 'react';

import { cn } from '@/lib/utils';

const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('rounded shadow border border-other-stroke flex-1', className)} {...props} />
));
Card.displayName = 'Card';

const CardHeaderTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('typo-smallest uppercase', className)} {...props}>
      {props.children}
    </p>
  ),
);

CardHeaderTitle.displayName = 'CardHeaderTitle';

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex flex-row justify-between items-center px-4 py-2 bg-light-gray', className)}
      {...props}
    >
      {props.children}
    </div>
  ),
);

CardHeader.displayName = 'CardHeader';

const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn('px-4 py-3', className)} {...props}>
        {props.children}
      </div>
    );
  },
);
CardContent.displayName = 'CardContent';

const CardDivider = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('h-[1px]  border-b border-other-stroke', className)} {...props} />
  ),
);
CardDivider.displayName = 'CardDivider';

const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('typo-primary-500 mb-3 truncate', className)} {...props} />
  ),
);
CardTitle.displayName = 'CardTitle';

const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('typo-secondary text-secondary-text truncate', className)} {...props} />
  ),
);
CardDescription.displayName = 'CardDescription';

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('', className)} {...props} />,
);
CardFooter.displayName = 'CardFooter';

const CardFooterItem = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex flex-row justify-between items-center mb-3', className)} {...props} />
  ),
);
CardFooterItem.displayName = 'CardFooterItem';

export {
  Card,
  CardContent,
  CardDescription,
  CardDivider,
  CardFooter,
  CardFooterItem,
  CardHeader,
  CardHeaderTitle,
  CardTitle,
};
